export default "__VITE_ASSET__DpuwCtx4__"